import apiClient from "../clinet";

// Get all galleries
const getGalleries = async () => {
  const response = await apiClient.get("/gallery");
  return response.data;
};

// Get single gallery by ID
const getGalleryById = async (id: string | number) => {
  const response = await apiClient.get(`/gallery/${id}`);
  return response.data;
};

// Create new gallery
const createGallery = async (galleryData: any) => {
  const response = await apiClient.post("/galleries", galleryData);
  return response.data;
};

// Update gallery
const updateGallery = async ({
  id,
  data,
}: {
  id: string | number;
  data: any;
}) => {
  const response = await apiClient.put(`/galleries/${id}`, data);
  return response.data;
};

// Delete gallery
const deleteGallery = async (id: string | number) => {
  const response = await apiClient.delete(`/galleries/${id}`);
  return response.data;
};

export default {
  getGalleries,
  getGalleryById,
  createGallery,
  updateGallery,
  deleteGallery,
};
